import { render, staticRenderFns } from "./customerCountTabs.vue?vue&type=template&id=646844a5&scoped=true"
import script from "./customerCountTabs.vue?vue&type=script&lang=js"
export * from "./customerCountTabs.vue?vue&type=script&lang=js"
import style0 from "./customerCountTabs.vue?vue&type=style&index=0&id=646844a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646844a5",
  null
  
)

export default component.exports